import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getOutlets, addOutlet, deleteOutlet, updateOutlet } from "../apinew";
import { Store, Plus, Save, X, Edit2, Trash2, MapPin } from "lucide-react";

export default function OutletPage() {
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const ownerId = currentUser?.user_id || currentUser?.id || "";

  const [outlets, setOutlets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    outlet_id: null,
    owner_id: ownerId,
    name: "",
    address: "",
  });

  const resetForm = () =>
    setForm({
      outlet_id: null,
      owner_id: ownerId,
      name: "",
      address: "",
    });

  const load = async () => {
    try {
      setLoading(true);

      const res = await getOutlets();
      const list = Array.isArray(res) ? res : res?.data ?? [];

      setOutlets(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error("Gagal load outlet:", err);
      setOutlets([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleAddOrUpdate = async () => {
    if (!form.name) return alert("Nama outlet wajib diisi");

    const payload = {
      owner_id: ownerId,
      name: form.name,
      address: form.address,
    };

    try {
      setSaving(true);

      if (form.outlet_id) {
        await updateOutlet(form.outlet_id, payload);
      } else {
        await addOutlet(payload);
      }

      resetForm();
      await load();
    } catch (err) {
      console.error("Gagal simpan outlet:", err);
      alert(
        err.response?.data?.message || err.message || "Gagal menyimpan outlet"
      );
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (o) => {
    setForm({
      outlet_id: o.outlet_id,
      owner_id: ownerId,
      name: o.name || "",
      address: o.address || "",
    });
  };

  const handleDelete = async (id) => {
    // eslint-disable-next-line no-restricted-globals
    if (!window.confirm("Yakin ingin menghapus outlet ini?")) return;

    try {
      await deleteOutlet(id);
      await load();
    } catch (err) {
      console.error("Gagal hapus outlet:", err);
      alert(
        err.response?.data?.message || err.message || "Gagal menghapus outlet"
      );
    }
  };

  return (
    <div style={{ padding: "24px", minHeight: "100vh", background: "#f8fafc" }}>
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        style={{ marginBottom: "24px" }}
      >
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "700",
            color: "#0f172a",
            marginBottom: "4px",
          }}
        >
          Outlet
        </h2>
        <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>
          Kelola lokasi bisnis Anda
        </p>
      </motion.div>

      {/* Form Card */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        style={{
          background: "#ffffff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          padding: "24px",
          marginBottom: "24px",
          boxShadow:
            "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        }}
      >
        <h3
          style={{
            fontSize: "16px",
            fontWeight: "600",
            color: "#0f172a",
            marginBottom: "20px",
          }}
        >
          {form.outlet_id ? "Edit Outlet" : "Tambah Outlet Baru"}
        </h3>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "16px",
          }}
        >
          <div>
            <label
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: "500",
                color: "#374151",
                marginBottom: "6px",
              }}
            >
              Nama Outlet
            </label>
            <input
              placeholder="Masukkan nama outlet"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              onFocus={(e) => {
                e.currentTarget.style.border = "1px solid #3b82f6";
                e.currentTarget.style.boxShadow =
                  "0 0 0 3px rgba(59, 130, 246, 0.1)";
              }}
              onBlur={(e) => {
                e.currentTarget.style.border = "1px solid #e2e8f0";
                e.currentTarget.style.boxShadow = "none";
              }}
              style={{
                width: "100%",
                padding: "10px 12px",
                border: "1px solid #e2e8f0",
                borderRadius: "6px",
                fontSize: "14px",
                color: "#0f172a",
                outline: "none",
                transition: "all 0.2s ease",
              }}
            />
          </div>

          <div>
            <label
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: "500",
                color: "#374151",
                marginBottom: "6px",
              }}
            >
              Alamat
            </label>
            <input
              placeholder="Masukkan alamat"
              value={form.address}
              onChange={(e) => setForm({ ...form, address: e.target.value })}
              onFocus={(e) => {
                e.currentTarget.style.border = "1px solid #3b82f6";
                e.currentTarget.style.boxShadow =
                  "0 0 0 3px rgba(59, 130, 246, 0.1)";
              }}
              onBlur={(e) => {
                e.currentTarget.style.border = "1px solid #e2e8f0";
                e.currentTarget.style.boxShadow = "none";
              }}
              style={{
                width: "100%",
                padding: "10px 12px",
                border: "1px solid #e2e8f0",
                borderRadius: "6px",
                fontSize: "14px",
                color: "#0f172a",
                outline: "none",
                transition: "all 0.2s ease",
              }}
            />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: "8px",
            marginTop: "20px",
            justifyContent: "flex-end",
          }}
        >
          {form.outlet_id && (
            <button
              onClick={resetForm}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = "0.9";
                e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.08)";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = "1";
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.transform = "translateY(0)";
              }}
              style={{
                padding: "8px 16px",
                border: "1px solid #e2e8f0",
                borderRadius: "6px",
                background: "#ffffff",
                color: "#64748b",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                transition: "all 0.2s ease",
              }}
            >
              <X size={16} />
              Batal
            </button>
          )}
          <button
            onClick={handleAddOrUpdate}
            disabled={saving}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = "0.9";
              e.currentTarget.style.boxShadow =
                "0 2px 6px rgba(59,130,246,0.3)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = saving ? 0.7 : 1;
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.transform = "translateY(0)";
            }}
            style={{
              padding: "8px 16px",
              border: "none",
              borderRadius: "6px",
              background: form.outlet_id ? "#f59e0b" : "#3b82f6",
              color: "#ffffff",
              fontSize: "14px",
              fontWeight: "500",
              cursor: saving ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              opacity: saving ? 0.7 : 1,
              transition: "all 0.2s ease",
            }}
          >
            {form.outlet_id ? <Save size={16} /> : <Plus size={16} />}
            {saving
              ? "Menyimpan..."
              : form.outlet_id
              ? "Perbarui"
              : "Tambah Outlet"}
          </button>
        </div>
      </motion.div>

      {/* Outlets Grid */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        {loading ? (
          <div
            style={{ padding: "48px", textAlign: "center", color: "#94a3b8" }}
          >
            Memuat outlet...
          </div>
        ) : outlets.length === 0 ? (
          <div
            style={{
              background: "#ffffff",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
              padding: "48px",
              textAlign: "center",
              color: "#94a3b8",
            }}
          >
            Belum ada outlet. Tambahkan outlet pertama Anda di atas.
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
              gap: "16px",
            }}
          >
            {outlets.map((outlet, idx) => (
              <motion.div
                key={outlet.outlet_id}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: idx * 0.05 }}
                style={{
                  background: "#ffffff",
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0",
                  padding: "20px",
                  boxShadow:
                    "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                  position: "relative",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow =
                    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow =
                    "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                {/* Icon */}
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "10px",
                    background:
                      "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  <Store size={24} color="#ffffff" strokeWidth={2} />
                </div>

                {/* Name */}
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#0f172a",
                    marginBottom: "8px",
                  }}
                >
                  {outlet.name}
                </h3>

                {/* Address */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "8px",
                    marginBottom: "16px",
                  }}
                >
                  <MapPin
                    size={16}
                    color="#94a3b8"
                    style={{ marginTop: "2px", flexShrink: 0 }}
                  />
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#64748b",
                      margin: 0,
                      lineHeight: "1.5",
                    }}
                  >
                    {outlet.address || "No address specified"}
                  </p>
                </div>

                {/* Actions */}
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    paddingTop: "16px",
                    borderTop: "1px solid #f1f5f9",
                  }}
                >
                  <button
                    onClick={() => handleEdit(outlet)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.opacity = "0.9";
                      e.currentTarget.style.boxShadow =
                        "0 2px 6px rgba(245,158,11,0.25)";
                      e.currentTarget.style.transform = "translateY(-1px)";
                      e.currentTarget.style.background = "#fde68a";
                      e.currentTarget.style.border = "1px solid #f59e0b";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.opacity = "1";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.background = "#fef3c7";
                      e.currentTarget.style.border = "1px solid #fde68a";
                    }}
                    style={{
                      flex: 1,
                      padding: "8px 12px",
                      border: "1px solid #fde68a",
                      borderRadius: "6px",
                      background: "#fef3c7",
                      color: "#92400e",
                      fontSize: "13px",
                      fontWeight: "500",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      transition: "all 0.2s ease",
                    }}
                  >
                    <Edit2 size={14} />
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(outlet.outlet_id)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.opacity = "0.9";
                      e.currentTarget.style.boxShadow =
                        "0 2px 6px rgba(220,38,38,0.25)";
                      e.currentTarget.style.transform = "translateY(-1px)";
                      e.currentTarget.style.background = "#fecaca";
                      e.currentTarget.style.border = "1px solid #ef4444";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.opacity = "1";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.background = "#fee2e2";
                      e.currentTarget.style.border = "1px solid #fecaca";
                    }}
                    style={{
                      flex: 1,
                      padding: "8px 12px",
                      border: "1px solid #fecaca",
                      borderRadius: "6px",
                      background: "#fee2e2",
                      color: "#991b1b",
                      fontSize: "13px",
                      fontWeight: "500",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      transition: "all 0.2s ease",
                    }}
                  >
                    <Trash2 size={14} />
                    Delete
                  </button>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </motion.div>
    </div>
  );
}
